import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Calendar from "react-calendar";
import MiniCalendar from "../calendarpage/MiniCalendar";
import { Avatar, Button, Card, Divider, Typography } from "@mui/material";
import {
  AccessTime,
  AccessTimeFilled,
  ChevronRightSharp,
  Person,
} from "@mui/icons-material";
import { gql, useQuery } from "@apollo/client";
import Error from "../Error";
import { getUsers } from "../../graphql/querys";

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        height: "30%",
      }}
    >
      <div>
        <h1>404 - Page not found</h1>
        <p>The requested page could not be found.</p>
      </div>
    </div>
  );
};
function UserEventPage(props) {
  const { user } = useParams();
  const [selectedDate, setSelectedDate] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const {
    loading: usersLoading,
    error: usersError,
    data: usersData,
  } = useQuery(getUsers, {
    variables: { url: user },
  });
  const navigate = useNavigate();
  if (usersLoading) return "Loading";
  if (usersError) return <Error />;
  const data = usersData.users.find((obj) => obj.url == user);
  const events = props.data.filter(
    (obj) => obj.userId == data?.id && !obj.hidden
  );
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {!data || !usersData ? (
        <NotFound />
      ) : (
        <Card
          className="event-card"
          style={{
            display: "flex",
            width: "90%",
            maxWidth: selectedDate ? "1000px" : "800px",
            height: "700px",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "420px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "15px",
              width: "100%",
              paddingTop: "40px",
            }}
          >
            <Avatar sx={{ width: 44, height: 44 }}>
              {data.url.toUpperCase().slice(0, 1)}
            </Avatar>
            <Typography>{data.username}</Typography>
            <Typography style={{ maxWidth: "300px", textAlign: "center" }}>
              {data.desc}
            </Typography>
            <div
              style={{
                maxHeight: "470px",
                overflow: "auto",
                overflowX: "hidden",
                width: !events.length ? "100%" : "50%",
                maxWidth: !events.length ? "100%" : "320px",
                minWidth: "320px",
                display: !events.length && "flex",
                alignItems: "center",
                justifyContent: "center",
                height: !events.length && "300px",
              }}
            >
              {!events.length && (
                <Typography variant="h3" style={{ opacity: "50%" }}>
                  No events to display
                </Typography>
              )}
              {events.map((val) => (
                <div
                  className="bookingBox"
                  style={{
                    border: "none",
                    borderTop: "1px solid rgb(230, 230, 230)",
                    display: "flex",
                    maxHeight: "60px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      gap: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="circle"
                      style={{ background: val.color }}
                    ></div>
                    {val.name}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {" "}
                    <Typography style={{ fontSize: "0.9em", opacity: "70%" }}>
                      {val.length} mins
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={() =>
                        navigate(
                          window.location.pathname.replace(/\/$/, "") +
                            "/events/" +
                            val.link +
                            "?back=1"
                        )
                      }
                      style={{background:"#d9bca9"}}
                    >
                      Book
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Add your custom content here */}
        </Card>
      )}
    </div>
  );
}

export default UserEventPage;
